// src/pages/DashboardPage.jsx
import React from "react";
import AdminNavbar from "../components/AdminNavbar";
import { Box, Typography, Container } from "@mui/material";

export default function DashboardPage({ onLogout }) {
  return (
    <>
      <AdminNavbar onLogout={onLogout} />
      <Container maxWidth="lg">
        <Box sx={{ mt: 6 }}>
          <Typography variant="h4" fontWeight={600}>
            Καλώς ήρθατε στο Admin Dashboard!
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Εδώ μπορείτε να διαχειριστείτε χρήστες, συνομιλίες και να δώσετε εντολές μέσω Chat.
          </Typography>
        </Box>
      </Container>
    </>
  );
}
